import * as React from 'react';
import CustomMultipleSelect from './ImageProcessingCustomMultipleSelect';
import { useRoomTags } from '../state/useRoomTags';
import { AuthenticatedUser } from '../../../../../../shared/types';
import FailureSnackbar from '../../../../../../shared/feedback/FailureSnackbar';

export type RoomTag = {
    value: string;
    displayName: string;
};

export type RoomTaggingLabels = {
    roomTaggingInputLabel: string;
    roomTaggingAddTag: string;
    roomTag: (displayName: string) => string;
    errors: {
        addRoomTag: string;
        deleteRoomTag: string;
    };
};

type ImageProcessingRoomTaggingProps = {
    user: AuthenticatedUser;
    availableRoomCategories: RoomTag[];
    existingRoomCategories: RoomTag[];
    labels: RoomTaggingLabels;
    orderId: number;
    imageId: number;
};

export default function ImageProcessingRoomTagging({
    user,
    availableRoomCategories,
    existingRoomCategories,
    labels,
    orderId,
    imageId
}: ImageProcessingRoomTaggingProps) {
    let {
        roomTags,
        handleAddRoomTags,
        handleDeleteRoomTag,
        openAddErrorSnackbar,
        handleCloseAddErrorSnackbar,
        openDeleteErrorSnackbar,
        handleCloseDeleteErrorSnackbar
    } = useRoomTags({
        user,
        availableRoomCategories,
        existingRoomCategories,
        imageId,
        orderId
    });

    let inputRef = React.useRef(null);

    return (
        <div
            style={{
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                zIndex: 3000
            }}
        >
            <CustomMultipleSelect
                onAddRoomTags={handleAddRoomTags}
                onDeleteRoomTag={handleDeleteRoomTag}
                roomTags={roomTags}
                availableRoomCategories={availableRoomCategories}
                labels={labels}
                ref={inputRef}
            />
            <FailureSnackbar
                open={openAddErrorSnackbar}
                onClose={handleCloseAddErrorSnackbar}
                text={labels.errors.addRoomTag}
            />
            <FailureSnackbar
                open={openDeleteErrorSnackbar}
                onClose={handleCloseDeleteErrorSnackbar}
                text={labels.errors.deleteRoomTag}
            />
        </div>
    );
}
